import React from 'react';
import styled from 'styled-components';
import { formatSaldo } from '../../utils/formatters';
import { MONEDA_MOVIMIENTO, bucketDeMoneda } from '../../constants/monedas';

const AlertBanner = styled.div`
  background-color: ${props => props.theme.colors.warning};
  border: 1px solid #F59E0B;
  border-radius: ${props => props.theme.borderRadius};
  padding: 1rem 1.25rem;
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
`;
const AlertTitle = styled.p`
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: #92400E;
`;
const AlertNote = styled.p`
  margin: 0.15rem 0 0.5rem 0;
  font-size: 0.75rem;
  color: #92400E;
`;
const AlertRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 0.3rem 0;
  font-size: 0.85rem;
`;
const AlertCliente = styled.span`
  flex: 1;
  cursor: pointer;
  text-decoration: underline dotted;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const AlertSaldo = styled.span`
  font-weight: 700;
  color: ${props => props.theme.colors.errorText};
  white-space: nowrap;
`;
const AlertButton = styled.button`
  font-family: ${props => props.theme.typography.fontFamily};
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.textPrimary};
  border: none;
  border-radius: ${props => props.theme.borderRadius};
  padding: 0.3rem 0.7rem;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  &:hover { background-color: #333; }
`;
const AlertMore = styled.p`
  margin: 0.3rem 0 0 0;
  font-size: 0.75rem;
  color: #92400E;
`;

const MAX_ALERT_ROWS = 5;

const DeudoresAlertCard = ({ moneda, deudores, onOpenDesglose, onPrecargarCaucion }) => {
  const format = (value) => formatSaldo(value, moneda);
  const monedaCaucion = MONEDA_MOVIMIENTO[bucketDeMoneda(moneda)];

  return (
    <AlertBanner>
      <AlertTitle>
        ⚠ {deudores.length} {deudores.length === 1 ? 'cuenta deudora' : 'cuentas deudoras'} sin caución cargada hoy
      </AlertTitle>
      <AlertNote>Montos según saldo proyectado del día.</AlertNote>
      {deudores.slice(0, MAX_ALERT_ROWS).map(entry => (
        <AlertRow key={entry.nroComitente}>
          <AlertCliente onClick={() => onOpenDesglose(entry)} title="Click para ver desglose">
            {entry.nombre}
          </AlertCliente>
          <AlertSaldo>{format(entry.saldoProyectado)}</AlertSaldo>
          <AlertButton
            onClick={() => onPrecargarCaucion({
              nroComitente: entry.nroComitente,
              nombre: entry.nombre,
              moneda: monedaCaucion,
              saldo: entry.saldoProyectado,
            })}
          >
            Precargar caución
          </AlertButton>
        </AlertRow>
      ))}
      {deudores.length > MAX_ALERT_ROWS && (
        <AlertMore>y {deudores.length - MAX_ALERT_ROWS} más…</AlertMore>
      )}
    </AlertBanner>
  );
};

export default DeudoresAlertCard;
